export type Colour = 'purple' | 'pink' | 'blue' | 'green' | 'yellow' | 'orange';

type ColourMap = {
  [key in string]: string;
};

export const colourMap: ColourMap = {
  purple: '#8138E0',
  pink: '#E51565',
  blue: '#006FE6',
  green: '#3AD356',
  yellow: '#FBB200',
  orange: '#DB3700'
};

export type IllustrationColourProps = {
  colour?: Colour;
};

export const colourOptions = Object.keys(colourMap);
